import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ContractorMobileCard = ({ contractor, onClick }) => {
  const getAvailabilityBadge = (status) => {
    const badges = {
      available: { label: 'Available', className: 'bg-success/10 text-success' },
      busy: { label: 'Busy', className: 'bg-warning/10 text-warning' },
      on_leave: { label: 'On Leave', className: 'bg-muted text-muted-foreground' },
      unavailable: { label: 'Unavailable', className: 'bg-destructive/10 text-destructive' }
    };
    return badges?.[status] || badges?.available;
  };

  const availabilityBadge = getAvailabilityBadge(contractor?.availabilityStatus);
  const rating = contractor?.rating || 0;
  const totalProjects = contractor?.totalProjects || 0;

  return (
    <div className="bg-card rounded-xl p-4 shadow-sm hover:shadow-md transition-shadow cursor-pointer" onClick={onClick}>
      <div className="flex items-start gap-3 mb-3">
        <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0">
          {contractor?.avatar ? (
            <img src={contractor?.avatar} alt={contractor?.name} className="w-12 h-12 rounded-full object-cover" />
          ) : (
            <Icon name="User" size={24} className="text-primary" />
          )}
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="font-semibold text-foreground truncate">{contractor?.name}</h3>
          <p className="text-sm text-muted-foreground truncate">{contractor?.role}</p>
        </div>
        <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium ${availabilityBadge?.className}`}>
          <span className="w-1.5 h-1.5 rounded-full bg-current"></span>
          {availabilityBadge?.label}
        </span>
      </div>

      <div className="grid grid-cols-2 gap-3 mb-3">
        <div className="flex items-center gap-2">
          <Icon name="Mail" size={16} className="text-muted-foreground" />
          <span className="text-sm text-muted-foreground truncate">{contractor?.email}</span>
        </div>
        {contractor?.phone && (
          <div className="flex items-center gap-2">
            <Icon name="Phone" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{contractor?.phone}</span>
          </div>
        )}
      </div>

      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-1">
            <Icon name="Star" size={16} className="text-warning fill-warning" />
            <span className="text-sm font-medium text-foreground">{rating?.toFixed(1)}</span>
          </div>
          <div className="flex items-center gap-1">
            <Icon name="Briefcase" size={16} className="text-muted-foreground" />
            <span className="text-sm text-muted-foreground">{totalProjects}</span>
          </div>
        </div>
        <Button variant="ghost" size="sm" iconName="ChevronRight">
          View
        </Button>
      </div>
    </div>
  );
};

export default ContractorMobileCard;